// extracted by mini-css-extract-plugin
module.exports =  {"root":"pUXNGgno5W6T8Qx_Vhpv","userInfo":"vUINx8gFCd0DJEUPVPU9","userName":"mSOgLIB4QCuPDnl3oThw","sponsoredLabel":"W2mWHjjCrhGuZwUvLcTv","bottomActions":"CrN_zRCkHNK5IkH9w5pR"};